export class LocalStorageHelper {

  private static key_prefix: string = `egcf-program-list.${process.env.VUE_APP_PROJECT}`;
  private static lang_key = `${LocalStorageHelper.key_prefix}.lang`;


  public static getLang(): string {
    return localStorage.getItem(this.lang_key);
  }

  public static setLang(lang: string): void {
    localStorage.setItem(this.lang_key, lang);
  }

}
